import React from 'react';

export default {
  fields: [
    {
      type: 'text',
      name: 'internalLabel',
      props: {
        label: <p><i className='asterisk icon inline'/>Step name</p>,
        required: true,
        helpContent: '',
        helpHeader: ''
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/components/steps/RenameStep/renameStepFormConfig.js